export default "__VITE_ASSET__9CBxoAy2__"